<template>
    <v-container>
      <v-card class="mx-auto align-end" flat>
        <v-row>
          <v-col>
            <p class="headline font-weight-bold" :style="{ color: `#AF8936`, fontSize: `27px !important` }">
              Reporte de Sentencias Publicadas por <b>Magistrado(a)</b>
            </p>
          </v-col>
        </v-row>
        <v-divider class="mb-15"></v-divider>
        <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
          <v-row class="align-end"> <!-- Pone todos los campos alineados abajo -->
            <!-- Tipo de Fecha -->
            <v-col cols="12" sm="4">
              <v-select
                :rules="[v => !!v || 'Seleccione tipo de fecha']"
                :items="listFechasSearch"
                v-model="tipo_fecha"
                label="Tipo de Fecha"
                item-value="id"
                item-text="value"
                clearable
                dense
                outlined
              />
            </v-col>
            <!-- Fecha Inicial -->
            <v-col cols="12" sm="4">
              <v-menu
                ref="dialogFecInicio"
                v-model="dialogFecInicio"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :rules="[v => !!v || 'Seleccione fecha inicial']"
                    v-model="fecha_inicio"
                    label="Fecha Inicial"
                    prepend-icon="mdi-calendar-outline"
                    readonly
                    v-on="on"
                    dense
                    outlined
                  />
                </template>
                <v-date-picker
                  v-model="fecha_inicio"
                  @input="dialogFecInicio = false"
                  locale="es-mx"
                  min="2010-01-01"
                  :max="new Date().toISOString().substr(0, 10)"
                />
              </v-menu>
            </v-col>
            <!-- Fecha Final -->
            <v-col cols="12" sm="4">
              <v-menu
                ref="dialogFecFin"
                v-model="dialogFecFin"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :rules="[v => !!v || 'Seleccione fecha final']"
                    v-model="fecha_fin"
                    label="Fecha Final"
                    prepend-icon="mdi-calendar-outline"
                    readonly
                    v-on="on"
                    dense
                    outlined
                  />
                </template>
                <v-date-picker
                  v-model="fecha_fin"
                  @input="dialogFecFin = false"
                  locale="es-mx"
                  :min="fecha_inicio"
                  :max="new Date().toISOString().substr(0, 10)"
                  @change="showReporte = false"
                />
              </v-menu>
            </v-col>
          </v-row>
          <!-- Boton buscar -->
          <v-row>
            <v-col cols="12" class="text-right">
              <v-btn 
                color="#616161" 
                class="white--text mt-3"
                :loading="loading" 
                @click.native="validate()"
              >
                <v-icon left>mdi-magnify</v-icon>
                Buscar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>

        <hr v-if="listTocas.length" class="my-6">
  
        <!-- ====================== RESULTADOS ====================== -->
        <div v-if="showReporte">
          <v-row ref="tableTop" class="mb-3">
            <v-col>
              <p class="overline">Resultados de la consulta</p>
            </v-col>
            <v-spacer></v-spacer>
            <v-col align="right" class="mr-3" :style="{ color: `#AF8936` }">
              <h4 >Total de magistrados involucrados: <b>{{ totalMagistrados }}</b></h4>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-sheet 
                class="pa-5 mx-auto"
                color="white"
                elevation="10"
                height="auto"
                max-width="800"
                width="100%"
              >
                <v-row>
                  <v-col v-if="listTocas.length">
                    <template>
                      <div>
                        <v-alert
                          border="top"
                          colored-border
                          type="info"
                          elevation="2"
                          class="text-start"
                        >
                          El total de tocas que se contabilizan corresponden al periodo desde el día: 
                          <br>
                          <b>{{ formatearFecha(fecha_inicio) }}</b> hasta el día <b>{{ formatearFecha(fecha_fin) }}</b> de las <b>18:00 horas.</b>
                        </v-alert>
                        <!-- <v-alert
                          border="top"
                          colored-border
                          type="info"
                          elevation="2"
                          class="text-start"
                        >
                          El total de tocas que se contabilizan corresponden al día seleccionado: 
                          <b>{{ formatearFecha(fecha_fin) }}</b> hasta las <b>18:00 horas.</b>
                        </v-alert> -->
                      </div>
                    </template>
                  </v-col>
                  <v-col cols="12">
                    <v-data-table
                      dense
                      :headers="headers"
                      :items="listTocas"
                      item-value="id"
                      item-text="numero"
                      class="elevation-1 letter-spacing"
                      :loading="loading"
                      light
                      :items-per-page="listTocas.length"
                      hide-default-footer
                      no-data-text="No se encontraron sentencias publicadas"
                      elevation="7"
                    >
                      <template v-slot:[`item.magistrado`] = "{ item }">
                        <td class="letter-spacing"> 
                            {{ item.magistrado }} 
                        </td>
                      </template>
                      <template v-slot:[`item.total_tocas`] = "{ item }">
                        <td class="text-center">
                          <b>{{ item.total_tocas }}</b> 
                        </td>
                      </template>
                      <!-- <template v-slot:[`item.created_at`] = "{ item }">
                        <td class="text-capitalize">
                            {{ item.created_at | formatDate }}
                        </td>
                      </template> -->
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-sheet
                class="pa-5 mx-auto"
                color="white"
                elevation="10"
                height="auto"
                width="100%"
              >
                <column-chart 
                  height="600px"
                  :data="chartData"
                  :colors="['#AF8936']"
                  label="Total de Tocas"
                  xtitle="Magistrados" ytitle="Sentencias"
                  :library="chartOptions"
                  :messages="{empty: 'No se Encontraron Resultados.'}"
                >
                </column-chart>
              </v-sheet>
            </v-col>
          </v-row>
        </div>
        <!-- <v-dialog
          v-model="progressLoading"
          persistent
          width="300"
        >
          <v-card
            color="#AF8936"
            dark
          >
            <v-card-text>
              <b>DESCARGANDO REPORTE...</b>
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog> -->
      </v-card>
    </v-container>
  </template>
  
  <script>
  import { mapGetters } from 'vuex';
  import moment from 'moment';
  
  const Swal = require('sweetalert2');
    export default {
      data: () => ({
        path: process.env.VUE_APP_PATH_DOWNLOAD,
        progressLoading: false,
        dialogFecInicio: false,
        dialogFecFin: false,
        tipo_fecha: '',
        fecha_inicio: '',
        fecha_fin:'',
        disabledFechaFin: true,
        maxFechaFin:'',
        showReporte: false,
        totalMagistrados:'',
        valid: true,
        magistrado_id:'',
        role_id:'',
        dialog: false,
        loading:false,
        listFechasSearch:[ 
          { id:'emision', value: 'Fecha Emisión de Sentencia' },
          { id:'publicacion', value: 'Fecha Publicación en Página Web' },
          { id:'creado', value: 'Fecha de Creacion en Base de Datos' },
        ],
        headers: [
          { text: 'Magistrado', value: 'magistrado', sortable: false},
          { text: 'Total de tocas', value: 'total_tocas', align: 'center', sortable: false},
          // { text: 'Sala', value: 'magistrado' },
          // { text: 'Ultimo toca registrado', value: 'created_at' },
        ],
        colors:[
          [
            // '#AF8936', '#607D8B', '#0b6e00', '#006ca2', 
            // '#ff3333', '#ff8203', '#9C27B0', '#009688', 
            // '#d60001', '#1d2e4c', '#FDD835', '#00acc1', 
            // '#c62828', '#263238', '#fdd835', '#AF8936'
          ]
        ],
        notBlankRules: [v => !!v || 'Este campo es requerido'],
      }),
      computed:{
        chartData() {
          // Formato que espera Chartkick: [ [label, valor], ... ]
          return this.listTocas.map(item => [item.magistrado, item.total_tocas])
        },
        chartOptions() {
          return {
            animation: {
              duration: 1000,
              onComplete: function () {
                const chartInstance = this.chart;
                const ctx = chartInstance.ctx;

                ctx.font = 'bold 15px sans-serif';
                ctx.fillStyle = '#000';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'bottom';

                this.data.datasets.forEach(function (dataset, i) {
                  const meta = chartInstance.controller.getDatasetMeta(i);
                  if (!meta.hidden) {
                    meta.data.forEach(function (bar, index) {
                      const value = dataset.data[index];
                      if (value != null) {
                        const x = bar._model.x;
                        const y = bar._model.y;
                        ctx.fillText(value, x, y - 8);
                      }
                    });
                  }
                });
              }
            },
            legend: {
              display: false
            },
            tooltips: {
              bodyFontSize: 14,
              titleFontSize: 16
            },
            scales: {
              xAxes: [{
                ticks: {
                  fontSize: 14,
                  autoSkip: false,
                  maxRotation: 50,
                  minRotation: 50,
                  callback: function(value) {
                    return value; // evita que Chart.js modifique el texto
                  }
                }
              }],
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  fontSize: 14
                }
              }]
            }
          };
        },
        ...mapGetters([
          "listTocas", "listMagistrados", "currentUser"
        ])
      },
      mounted(){
        this.getMagistrados()
        this.role_id = this.currentUser.roles[0].id
      },
      methods:{
        formatearFecha(fecha) {
          return moment(fecha).format('D [de] MMMM [de] YYYY')
        },
        // getColorTocas(tocas) {
        //   if (tocas >= 10) return 'green'
        //   else if (tocas >= 5 && tocas <= 9 ) return 'orange'
        //   else return 'red'
        // },
        scrollTop() {
          this.$nextTick(() => {
            if (this.$refs.tableTop) {
                this.$refs.tableTop.scrollIntoView({
                    behavior: "smooth"
                });
            }
          });
        },
        // calculateFechaFin(){
        //     this.showReporte = false;

        //     const fechaStr = new Date(this.fecha_inicio).toISOString().substr(0, 10); // "YYYY-MM-DD"
        //     this.fecha_fin = fechaStr;
        //     this.maxFechaFin = fechaStr;
        //     this.disabledFechaFin = false;
        // },
        getMagistrados() {
            this.loading = true;
            this.$store.dispatch("GET_MAGISTRADOS",  { url: "/magistrados" } ).then(response => {
                // console.log(response.data);
                this.loading = false;
            })
            .catch(error => {
                console.log(error);
            });
        },
        validate() {
          if (this.$refs.form.validate()) {
            this.loading = true
            this.buscar()
          }
        },
        buscar() {
          this.loading = true;
          this.$store.dispatch("GET_TOCAS_REPORTE", { url:"/tocas-magistrados",
            data: {
                // magistrado_id: this.magistrado_id || this.currentUser.magistrado_data.id,
                tipo_fecha: this.tipo_fecha,
                fecha_ini: this.fecha_inicio,
                fecha_fin: this.fecha_fin,
            }
          })
          .then((response) => {
            this.totalMagistrados = this.listTocas.length
            this.loading = false
            this.showReporte = true
            this.scrollTop();
          })
          .catch(error => {
            console.log(error);
          });
        },
        reportePdf(){
          this.progressLoading = true
          this.$store.dispatch("GET_PDF", { url:"/tocas/reportePDF",
            data: {
              fecha_ini: this.fecha_inicio,
              fecha_fin: this.fecha_fin,
              magistrado_id: this.magistrado_id || this.currentUser.sala_data.id,
            }
          }).then((response) => {
            this.progressLoading = false
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            let inicio = this.fecha_inicio
            let fin = this.fecha_fin
            link.setAttribute('download', 'Reporde de ' + inicio +' al '+ fin +'.pdf');
            document.body.appendChild(link);
            link.click();
          })
          .catch(err => {
            console.log(err);
            this.progressLoading = false
            this.$swal({
              title: 'Error al descargar el PDF!!!',
              icon: 'error',
              timer: 1000,
            })
          });
        }
      }
    }
  </script>

  <style scoped>
    @media screen and (min-width: 740px) {
      .letter-spacing {
        letter-spacing: 1px;
      }
    }
  </style>
  